/** O sinal de que o assistente está trabalhando, no lugar da resposta que ainda
 *  não começou. A folha da marca respira e três pontos acendem em sequência,
 *  com um rótulo curto ao lado. Aparece no instante em que a pergunta sai, e
 *  fica até o primeiro trecho de texto chegar; os cartões de etapa entram acima
 *  dele conforme as ferramentas trabalham. Só opacidade e deslocamento, e sob
 *  prefers-reduced-motion nada se move. */
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useI18n } from '@/core/i18n/useI18n'
import { Leaf } from '@/shared/leaf/LeafDefs'

export function Pensando() {
  const { t } = useI18n()
  return (
    <Box
      className="assistente-pensando anim-fade-in"
      role="status"
      aria-label={t('assistente.resposta.pensando')}
      sx={{ display: 'flex', alignItems: 'center', gap: 1.25, py: 0.5, color: 'text.secondary' }}
    >
      <Box className="assistente-pensando-folha" sx={{ display: 'flex', color: 'leaf.main', flex: 'none' }} aria-hidden>
        <Leaf style={{ height: 16, width: 'auto' }} />
      </Box>
      <Typography component="span" sx={{ fontSize: '0.8125rem', fontWeight: 500 }}>
        {t('assistente.resposta.pensandoCurto')}
      </Typography>
      <Box className="assistente-pensando-pontos" aria-hidden sx={{ display: 'flex', gap: 0.5, color: 'leaf.main' }}>
        <span /><span /><span />
      </Box>
    </Box>
  )
}
